import React, { useState } from "react";
import axios from "axios";

const Payments = () => {
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");

  // User-specific transactions
  const userTransactions = {
    user1: [
      { amount: 100, status: "Success", desc: "user1@example.com", date: "2024-01-01" },
      { amount: 50, status: "Failed", desc: "user1@example.com", date: "2024-01-02" },
    ],
    '3867deec0cc9d459e47970652ecf123f4671b667352c8fb992a00990402ec074': [
      { amount: "1000 USDT", status: "Success", desc: "AED to USDT", date: "2024-12-17" },
    ],
    user3: [
      { amount: 300, status: "Success", desc: "user3@example.com", date: "2024-01-05" },
      { amount: 100, status: "Failed", desc: "user3@example.com", date: "2024-01-06" },
    ],
  };

  const loggedInUser = localStorage.getItem("username") || "default";
  const transactions = userTransactions[loggedInUser] || [
    { amount: 0, status: "N/A", desc: "N/A", date: "N/A" },
  ];

  const handlePayment = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      setError("Please enter a valid amount");
      return;
    }
    setError("");

    try {
      const response = await axios.post("/api/create-checkout-session", {
        amount: parseFloat(amount),
      });

      window.location.href = response.data.url; // Redirect to Stripe Checkout
    } catch (err) {
      console.error("Error initiating payment:", err);
      setError("Failed to initiate payment. Please try again.");
    }
  };

  return (
    <div className="payments-container">
      <h2>Make a Payment</h2>
      <div className="payment-form">
        <label htmlFor="amount">Enter Amount (AED):</label>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <input
          type="number"
          id="amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Amount in AED"
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        {error && <p className="error-message">{error}</p>}
        <button onClick={handlePayment} className="payment-button">
          Pay Now
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp; 
      </div>
      <h2>OR</h2>
      <h2><b>Direct Bank Transfer</b></h2>
      &nbsp;&nbsp;&nbsp;&nbsp; <label>Account: EQUITY FIN MARKETING MANAGEMENT L.L.C</label><br/>
      &nbsp;&nbsp;&nbsp;&nbsp; <label>Account No: 9666500508</label><br/>
      &nbsp;&nbsp;&nbsp;&nbsp; <label>IBAN: AE340860000009666500508</label><br/>
      &nbsp;&nbsp;&nbsp;&nbsp; <label>Bank: Wio Bank</label><br/>
      &nbsp;&nbsp;&nbsp;&nbsp; <label>BIC: WIOBAEADXXX</label><br/>
      <br/>
      <h2>Transaction History</h2>
      <div className="profile-table-wrapper">
        <table className="profile-table">
          <thead>
            <tr>
              <th>Coin</th>
              <th>Status</th>
              <th>Desc.</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((txn, index) => (
              <tr key={index}>
                <td>{txn.amount}</td>
                <td>{txn.status}</td>
                <td>{txn.desc}</td>
                <td>{txn.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Payments;
